import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Box, Typography, Grid, Divider } from '@material-ui/core'
import ArrowBackIosIcon from '@material-ui/icons/ArrowBack'
import crStyles from '../crStyles'
import { trackWidgetClick } from '../../../../../helpers/trackWidgetClick'

const CRaboutUs = ({ handleClick, data, widgetId }) => {
  const classes = crStyles()
  const dispatch = useDispatch()
  const handlePress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      handleClick(true)
    }
  }
  const handleNavClick = () => {
    trackWidgetClick(dispatch, 'CommuterResources', 'About Us Back Nav', {
      widgetId,
    })
    handleClick()
  }
  return (
    <Box>
      <Box
        className={classes.aboutUsHeaderContainer}
        tabIndex={0}
        onClick={handleNavClick}
        onKeyPress={handlePress}
      >
        <ArrowBackIosIcon className={classes.aboutUsHeaderBackArrow} />
        <Typography variant="h4" className={classes.aboutUsNavText}>
          {data.navText}
        </Typography>
      </Box>
      <Divider />
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className={classes.aboutUsTextContainer}
      >
        <Grid item>
          <div className={classes.aboutUsImageDiv}>
            <img src={data.imageFinal} alt="RCSA Logo" width="100%" />
          </div>
        </Grid>
        <Grid item>
          <Typography
            variant="body1"
            style={{ lineHeight: '18px' }}
            dangerouslySetInnerHTML={{
              __html: data.description,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  )
}
export default CRaboutUs
